import { Button, Text } from "@chakra-ui/react";
import useForm from "../../../hooks/useForm";
import { useLoginApi } from "../apis";
import { Box, useBreakpointValue } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useAlert } from "../../../hooks/useAlert";
import { useAppSelector } from "../../../store";
import InfoGropup from "../components/InfoGroup";
import { HightLightText } from "../sections/Auth.Footer";
import { useNavigate } from "react-router-dom";

const SignUpForm = () => {
  const isMobile = useBreakpointValue({ base: true, md: false });
  const [showForm, setShowForm] = useState(false);
  const { signupWithEmailAndPassword } = useLoginApi();
  const { message, loading } = useAppSelector((s) => s.auth);
  const navigate = useNavigate();
  const { showAlert, render: AlertRender, hideAlert } = useAlert();
  const { render: formRender, setLoading } = useForm<
    "email" | "name" | "password"
  >({
    initialValues: {
      email: {
        type: "email",
        value: "",
        label: "Email",
        placeholder: "Email",
      },
      name: {
        type: "text",
        value: "",
        placeholder: "Name",
        label: "Name",
        validation: {
          required: { value: true, message: "Name is required" },
        },
      },
      password: {
        type: "password",
        value: "",
        label: "Password",
        placeholder: "Password",
        showEye: true,
      },
    },
    inputSize: "lg",
    showLabel: isMobile!,
    submitLabel: "Sign Up",
    buttonWidth: "full",
    onSubmit: (data) => {
      signupWithEmailAndPassword(data as any);
    },
  });

  useEffect(() => {
    setLoading(loading);
  }, [loading, setLoading]);

  useEffect(() => {
    if (message) showAlert({ status: message.status, message: message.value });
    else hideAlert();
  }, [message]);

  const emailForm = (
    <Box>
      <Box>{formRender({ Body: <Box mt={".2rem"}></Box> })}</Box>
      <Text
        mt={".3rem"}
        color={"whiteAlpha.900"}
        textAlign={"center"}
        fontSize={"sm"}
      >
        By clicking above, I agree to bellu's {" "}
        <HightLightText onClick={() => navigate("/auth/")}>
          Terms
        </HightLightText>{" "}
         and {" "}
        <HightLightText onClick={() => navigate("/auth/")}>
          Privacy Policy
        </HightLightText>
      </Text>
    </Box>
  );

  const defaultForm = (
    <Box>
      <InfoGropup
        type="signup"
        sx={{
          flexDirection: "column-reverse",
          display: "flex",
        }}
      />
      <Button
        width="full"
        size={"lg"}
        variant={"secondary"}
        onClick={() => setShowForm(true)}
      >
        Join using Email
      </Button>
    </Box>
  );

  return (
    <Box pb={"2rem"}>
      <Text
        my={"1rem"}
        textAlign={"center"}
        fontSize={"2xl"}
        fontWeight={"bold"}
      >
        Create free account
      </Text>
      <Box mb={"1rem"}>{AlertRender}</Box>

      {showForm ? emailForm : defaultForm}
    </Box>
  );
};

export default SignUpForm;
